<template>
  <div class="drone-sensor-data-view" @click.stop>
    <MCard class="content" :title="name">
      <scrollView
        v-if="monitorList.length"
        :monitorList="monitorList"
        @showChart="showChartViewHandler"
        @coloseChartView="showChartViewFlag = false"
      />

      <div v-else class="empty-sensor-view">请点击设备订阅详情数据</div>
    </MCard>

    <div
      v-if="showChartViewFlag"
      class="sensor-chart-view"
      :style="{
        '--left': sensorChartLeft,
        '--arrowLeft': arrowLeft
      }"
    >
      <div class="arrow-box">
        <v-chart
          ref="mychart"
          :options="chartObj"
          style="height: 300px !important; width: 400px !important"
          :autoresize="true"
        ></v-chart>
      </div>
    </div>
  </div>
</template>
<script>
import MCard from '@/components/mCard/index';
import HeaderIcon from '@/assets/image/components/fire.png';
import scrollView from './scroll-view.vue';
import { isEmpty } from '@/utils/is';

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    seneorGrade: {
      type: Object,
      default: () => {}
    },
    seneorData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    MCard,
    scrollView
  },
  watch: {
    seneorData: {
      handler(newVal) {
        if (isEmpty(this.chartData)) {
          this.monitorList = newVal.map(item => ({
            ...item,
            chartOriginList: [],
            showChartList: [
              {
                dt: item.beginTime,
                value: item.value
              }
            ]
          }));

          this.chartData = this.monitorList;
        } else {
          this.monitorList = newVal;
          if (this.chartData.length == newVal.length) {
            newVal.forEach((item, index) => {
              this.chartData[index].chartOriginList.push({
                dt: item.beginTime || '',
                value: item.value
              });
            });
          } else {
            newVal.forEach((item, index) => {
              if (!this.chartData[index]) {
                this.chartData[index] = {
                  ...item,
                  chartOriginList: [
                    {
                      dt: item.beginTime,
                      value: item.value
                    }
                  ],
                  showChartList: [
                    {
                      dt: item.beginTime,
                      value: item.value
                    }
                  ]
                };
              }
            });
          }

          this.disposeChartData();
        }
        this.monitorList.forEach((item, index) => {
          let { deviceType, name, value } = item;
          if (!this.seneorGrade.hasOwnProperty(deviceType)) return;

          this.seneorGrade[deviceType].forEach(sitem => {
            if (sitem.sensorTypeCode.includes(name)) {
              sitem.deviceSensorTypeGradeDtos.forEach(sensorItem => {
                if (
                  value >= Number(sensorItem.gradeLowValue) &&
                  value <= Number(sensorItem.gradeHighValue)
                ) {
                  this.monitorList[index].color = sensorItem.gradeMark;
                }
              });
            }
          });
        });
      },
      deep: true
    }
  },
  data() {
    return {
      chartObj: {
        xAxis: {
          data: [],
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#FFF'
            }
          },
          itemStyle: {
            color: '#fff'
          }
        },
        yAxis: {
          type: 'value',
          scale: true,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#FFF'
            }
          }
        },
        grid: {
          left: '2%', // 调整左侧边距
          //   right: '10%', // 调整右侧边距
          //   bottom: '40%', // 调整下侧边距
          containLabel: true // 确保标签不会被遮挡
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        series: [
          {
            data: [],
            type: 'line'
          }
        ]
      },
      monitorList: [],
      chartData: [],
      showChartViewFlag: false,
      sensorChartLeft: '0px',
      arrowLeft: '306px',

      icon: {
        type: 'image',
        config: {
          src: HeaderIcon
        }
      }
    };
  },
  mounted() {
    this.timer = 0;
    document.addEventListener('click', this.bodyClosePops);

    // setInterval(() => {
    //   this.chartObj.series[0].data.push(Math.floor(Math.random() * 100));
    // }, 1000);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.bodyClosePops);
  },

  methods: {
    bodyClosePops() {
      if (this.showChartViewFlag) {
        this.showChartViewFlag = false;
      }
    },
    disposeChartData() {
      if (this.timer == 2) {
        this.chartData.forEach(item => {
          let max = Math.max.apply(
            Math,
            item.chartOriginList.map(item => item.value)
          );

          let allValues = item.chartOriginList.map(sitem => sitem.value);
          let index = allValues.indexOf(max);

          if (item.showChartList.length >= 30) {
            item.showChartList = item.showChartList.splice(1);
          }

          let isAdd = item.showChartList.every(sitem => {
            return sitem.dt < item.chartOriginList[index].dt;
          });

          if (isAdd) {
            item.showChartList.push({
              value: max,
              dt: item.chartOriginList[index].dt
            });
          }

          item.chartOriginList = [];
        });
        this.timer = 0;

        if (this.showChartViewFlag) {
          this.setChartDataHandler();
        }
      } else {
        this.timer += 1;
      }
    },

    // 展示仪表dialog
    showChartViewHandler(item, index) {
      this.$emit('chooseSensorIndex', item, index);
      this.showEchartsCurrentIndex = index;
      this.setChartDataHandler();

      this.showChartViewFlag = true;

      const clientDom = document.getElementsByClassName(`sensor-list-item${index}`)[0];
      let XLocation = clientDom.getBoundingClientRect().x;
      //   let width = clientDom.getBoundingClientRect().width;
      this.sensorChartLeft = XLocation - 50 + 'px';
    },
    setChartDataHandler() {
      let Xdata = this.chartData[this.showEchartsCurrentIndex].showChartList.map(
        item => this.formatDate(item.dt)
        //   item.dt
      );
      let NumberData = this.chartData[this.showEchartsCurrentIndex].showChartList.map(
        item => item.value
      );

      this.chartObj.series[0].data = NumberData;
      this.chartObj.xAxis.data = Xdata;
    },

    //  时间处理
    formatDate(dateString) {
      const options = {
        // year: 'numeric',
        // month: 'long',
        // day: 'numeric'
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      };

      const dict = {
        cn: 'zh-CN',
        en: 'en-US',
        es: 'es',
        ar: 'ar',
        fr: 'fr',
        ru: 'ru'
      };
      const locale = new Intl.DateTimeFormat().resolvedOptions().locale;

      return new Date(dateString).toLocaleDateString(dict[locale.value], options).split(' ')[1];
    }
  }
};
</script>

<style scoped lang="scss">
.drone-sensor-data-view {
  position: relative;
  background: linear-gradient(90deg, rgba(32, 62, 88, 0.3) 0%, rgba(32, 62, 88, 0.7) 100%);

  .empty-sensor-view {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-weight: 700;
  }

  .sensor-chart-view {
    left: var(--left);
    top: -270px;
    z-index: 1;
    position: absolute;
    .arrow-box {
      position: relative;
      width: 400px;
      height: 300px;
      background: rgba(17, 33, 50, 0.5);
      border: 2px solid #047eba;
      line-height: 100px;
      text-align: center;
    }

    .arrow-box::after {
      content: '';
      position: absolute;
      bottom: -15px;
      //   left: var(--arrowLeft);
      left: 15%;
      margin-left: -10px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid #047eba;
    }
  }
}
</style>
